import { HttpClient } from '@shared/adapters/HttpClient';
import type { OrderTracking } from '../models/Tracking';

export class TrackingApiAdapter {
  constructor(private httpClient: HttpClient) {}

  // GET /orders/{id}/tracking
  async getOrderTracking(orderId: number): Promise<OrderTracking> {
    const response = await this.httpClient.get<{ data: OrderTracking }>(
      `/orders/${orderId}/tracking`
    );
    // La API envía { data: { tracking_code, events, incidences } }
    return response.data;
  }
}
